// frontend/src/features/equipment/EquipmentSetupWizard/steps/WelcomeStep.tsx
import { Stack, Text, Paper, List, ThemeIcon } from '@mantine/core';
import { IconCircle } from '@tabler/icons-react';

interface CategoryInfo {
  name: string;
  description: string;
}

const CATEGORIES: CategoryInfo[] = [
  { name: 'Circulation', description: 'Return pumps, wavemakers' },
  { name: 'Lighting', description: 'Main display & refugium lights' },
  { name: 'Filtration', description: 'Skimmer, reactors, filter rollers' },
  { name: 'Control', description: 'Controllers, dosers, ATO' },
  { name: 'Other', description: 'Heaters, chillers, sterilization' },
];

export function WelcomeStep() {
  return (
    <Stack gap="md" data-testid="welcome-step">
      <Text>
        Let's walk through your equipment setup. We'll cover the main
        categories - skip anything you don't have.
      </Text>

      <Paper p="md" withBorder data-testid="category-list">
        <Text fw={500} mb="sm">
          What we'll cover:
        </Text>
        <List
          spacing="xs"
          icon={
            <ThemeIcon color="blue" size={16} radius="xl" variant="light">
              <IconCircle size={8} />
            </ThemeIcon>
          }
        >
          {CATEGORIES.map((category) => (
            <List.Item key={category.name}>
              <Text component="span" fw={500}>
                {category.name}
              </Text>
              <Text component="span" c="dimmed" ml={8}>
                {category.description}
              </Text>
            </List.Item>
          ))}
        </List>
      </Paper>

      <Text size="sm" c="dimmed">
        Takes about 2-3 minutes. You can add more details anytime.
      </Text>
    </Stack>
  );
}
